export enum SseEndpointsSuffixes {
  orders = 'orders/sse',
  vendorsRegistrations = 'admin/vendors/sse',
  offerings = 'offerings/sse',
}
